import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as router from '@attain-apps/fe/web/main/lib/router'

import * as me from '../../../../me'
import { Api } from '../../api.service'
import type { TypeParams } from '../../types'

import { getActionsConfig } from './actions'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * TODO:
 */
export class Plugin extends ec.plugins.Plugin<
  TypeParams,
  typeof Plugin.id,
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static id = ec.plugins.Plugin.Id.Custom.create('RateReportContent')

  /** @see {@link Api} */
  public readonly api = ngCore.inject(Api)

  constructor({ collection }: Readonly<Plugin.constructor.Params>) {
    const meFeature = ngCore.inject(me.Feature)
    const _router = ngCore.inject(router.Router)
    super({
      actions: getActionsConfig(),
      collection,
      id: Plugin.id,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })
    this.feature.registerEffects(
      effects.displayReportOnRequest(this, meFeature, _router),
      effects.loadCurrentReportContentOnChange(this),
    )
  }
}
export namespace Plugin {
  export namespace constructor {
    export interface Params {
      collection: ec.Collection<TypeParams>
    }
  }
}
